let self = "";
var ws = "";
var lockReconnect = false; //避免重复连接
export const oncloseq = function () {
  ws.close()
}

export const initScoket = function (options) {
  var rawHeaderLen = 16;
  var packetOffset = 0;
  var headerOffset = 4;
  var verOffset = 6;
  var opOffset = 8;
  var seqOffset = 12;
  var Client = function (options) {
    var MAX_CONNECT_TIMES = 10;
    var DELAY = 15000;
    this.options = options || {};
    this.createConnect(MAX_CONNECT_TIMES, DELAY);
    this.authData = options.authData;
  };

  // eslint-disable-next-line no-unused-vars
  var appendMsg = function (text) {
    // console.log(text)
  };

  Client.prototype.createConnect = function (max, delay) {
    let selfs = this;
    self = this;
    // if (max === 0) {
    //   return;
    // }
    connect();
    var textDecoder = new TextDecoder();
    var textEncoder = new TextEncoder();
    var headerBuf = ""
    var headerView = ""
    var bodyBuf = ""
    var token = ""
    function connect() {
      ws = new WebSocket("wss://artronim-ws.artron.net/sub");
      ws.binaryType = "arraybuffer";
      function auth(authData) {
        // eslint-disable-next-line no-unused-vars
        // let { connectKey: key, mid, roomId } = authData;
        var key = authData.key,
          // mid = authData.mid,
          roomId = authData.roomId;
        // console.log(authData);
        // console.log(JSON.stringify(["identity"]));
        token = `{"mid":${1}, "room_id":"${roomId}", "platform":"web", "key":"${key}","accepts":[${1}],"identity":${typeof authData.identity == "string"
          ? JSON.stringify([authData.identity])
          : JSON.stringify(authData.identity)
          }}`;
        headerBuf = new ArrayBuffer(rawHeaderLen);
        headerView = new DataView(headerBuf, 0);
        bodyBuf = textEncoder.encode(token);
        headerView.setInt32(packetOffset, rawHeaderLen + bodyBuf.byteLength); //packetOffset 0 rawHeaderLen 16
        headerView.setInt16(headerOffset, rawHeaderLen); //headerOffset 4  rawHeaderLen 16
        headerView.setInt16(verOffset, 1); //verOffset 6
        headerView.setInt32(opOffset, 7); //opOffset 8
        headerView.setInt32(seqOffset, 1); // seqOffset 12
        ws.send(mergeArrayBuffer(headerBuf, bodyBuf));
        // console.log(token);
        // console.log(
        //   "send: auth token: ",
        //   headerBuf,
        //   bodyBuf,
        //   mergeArrayBuffer(headerBuf, bodyBuf)
        // );
      }
      ws.onopen = function () {
        // console.log("on open");
        auth(self.authData);
      };

      ws.onmessage = function (evt) {

        //  console.log("on onmessage");
        //  auth(self.authData);


        var data = evt.data;

        var dataView = new DataView(data, 0);
        var packetLen = dataView.getInt32(packetOffset);
        var headerLen = dataView.getInt16(headerOffset);
        //var ver = dataView.getInt16(verOffset);
        var op = dataView.getInt32(opOffset);

        // var seq = dataView.getInt32(seqOffset);
        switch (op) {
          case 8:
            // auth reply ok
            // // self.getpeople({})
            // document.getElementById("status").innerHTML =
            //     "<color style='color:green'>ok<color>";
            // appendMsg("receive: auth reply");
            // send a heartbeat to server
            //连接成功

            heartbeat();
            self.heartbeatInterval = setInterval(heartbeat, 30 * 1000);
            break;
          case 3:
            // receive a heartbeat from server
            // console.log("receive: heartbeat");
            appendMsg("receive: heartbeat reply");
            break;
          case 9:
            // batch message
            // console.log(op);
            for (
              var offset = rawHeaderLen;
              offset < data.byteLength;
              offset += packetLen
            ) {
              // parse
              packetLen = dataView.getInt32(offset);
              headerLen = dataView.getInt16(offset + headerOffset);
              //var ver = dataView.getInt16(offset + verOffset);
              op = dataView.getInt32(offset + opOffset);
              //var seq = dataView.getInt32(offset + seqOffset);
              var msgBody = textDecoder.decode(
                data.slice(offset + headerLen, offset + packetLen)
              );
              // let { content, source } = JSON.parse(
              //     msgBody
              // );
              options.onmessage(JSON.parse(msgBody));
            }
            break;
          case 7:
            break;
          default:
            // var msgBody = textDecoder.decode(data.slice(headerLen, packetLen));
            break;
        }
      };

      ws.onclose = function () {
        console.log('websocket服务关闭了');
        if (self.heartbeatInterval) clearInterval(self.heartbeatInterval);
        reConnect();
      };
      // ws.onerror = function (event) {
      //   console.log('websocket服务出错了');
      //    if (self.heartbeatInterval) clearInterval(self.heartbeatInterval);
      //   reConnect();
      // };
      // socket.onclose = function (event) {
      //   
      //   reconnect(wsUrl);
      // };

      self.ws = ws;
      function heartbeat() {

        headerBuf = new ArrayBuffer(rawHeaderLen);
        headerView = new DataView(headerBuf, 0);
        headerView.setInt32(packetOffset, rawHeaderLen + bodyBuf.byteLength); // packetOffset 0 rawHeaderLen 16
        headerView.setInt16(headerOffset, rawHeaderLen); //headerOffset 4  rawHeaderLen 16
        headerView.setInt16(verOffset, 1);
        headerView.setInt32(opOffset, 2);
        headerView.setInt32(seqOffset, 1);
        ws.send(mergeArrayBuffer(headerBuf, bodyBuf));
        // ws.send(headerBuf);
        // console.log(mergeArrayBuffer(headerBuf, bodyBuf))
        // debugger
      }

      //   function messageReceived(ver, body) {
      //     var notify = self.options.notify;
      //     if (notify) notify(body);
      //   }
      function mergeArrayBuffer(ab1, ab2) {
        var u81 = new Uint8Array(ab1),
          u82 = new Uint8Array(ab2),
          res = new Uint8Array(ab1.byteLength + ab2.byteLength);
        res.set(u81, 0);
        res.set(u82, ab1.byteLength);
        return res.buffer;
      }

      // eslint-disable-next-line no-unused-vars
      function char2ab(str) {
        var buf = new ArrayBuffer(str.length);
        var bufView = new Uint8Array(buf);
        for (var i = 0; i < str.length; i++) {
          bufView[i] = str[i];
        }
        return buf;
      }
    }
    // eslint-disable-next-line no-unused-vars
    function reConnect() {
      //没连接上会一直重连，设置延迟避免请求过多
        selfs.createConnect(--max, delay);
    }
  };
  return new Client({
    // eslint-disable-next-line no-unused-vars
    notify: function (data) {
      // console.log(data);
      // alert(JSON.stringify(data));
    },
    authData: options.authData
  });
};
